module.exports = __webpack_public_path__ + "static/media/balance-banner.71ca3b92.webp";